"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationAi',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    topicText: function topicText(task) {
      if (!task) return '';
      if (task.inputSnapshot) {
        try {
          var parsed = JSON.parse(task.inputSnapshot);
          if (parsed && parsed.topic) return parsed.topic;
        } catch (error) {
          // keep fallback
        }
      }
      return task.scene;
    },
    actionText: function actionText(value) {
      return {
        generate: '生成文案',
        send: '推送',
        track: '追踪意向',
        cancel: '取消'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationAiListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('种草主题', '新任务').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationAiSaveApi)({
          scene: 'prospecting',
          taskType: 'generate',
          channel: 'app',
          topic: value || '样板房探店'
        }).then(function () {
          _this2.$message.success('种草任务已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      var payload = {
        action: action
      };
      if (action === 'track') payload.intentionScore = 82;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationAiActionApi)(row.task.id, payload).then(function () {
          _this3.$message.success('种草任务已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};